<script>
	export let className = ''
</script>

<svg class={className} aria-hidden="true" focusable="false" data-prefix="fak" data-icon="nga-icon-arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="" style="width: 1em;"><path fill="currentColor" d="M308.8 84.8l-22.72 22.4L418.88 240H32v32h386.88l-132.8 132.8 22.72 22.4L480 256 308.8 84.8z"></path></svg>